import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { throwError } from 'rxjs';
import { PermissionsService } from '../services/permissions.service';

/**
 * Bulk-upload module actions stay available under the temporary zero-permission
 * fallback (including category/extra-field bulk DELETE and user suspend/activate).
 */
export function isBulkUploadAllowlistedForZeroPermissions(url: string): boolean {
  const path = (url || '').toLowerCase();
  return path.includes('/bulk-upload/') || path.includes('/workflow-conditions/');
}

/**
 * Requests the temporary zero-permission fallback must not be able to perform.
 * UI hides the buttons; this blocks the call if a control is still reachable.
 */
export function isDestructiveHttpRequest(method: string, url: string, body: unknown): boolean {
  const verb = (method || '').toUpperCase();
  const path = (url || '').toLowerCase();

  if (isBulkUploadAllowlistedForZeroPermissions(path)) {
    return false;
  }

  if (verb === 'DELETE') {
    return true;
  }
  if (path.includes('suspend-reference') || path.includes('suspend-activate/process')) {
    return true;
  }
  if (path.includes('disable-newsletters') || path.includes('disable-automatic-emails')) {
    return true;
  }
  if (/\/status(\?|$)/.test(path)) {
    return !!body && typeof body === 'object' && (body as { active?: boolean }).active === false;
  }
  return false;
}

export const destructiveActionInterceptor: HttpInterceptorFn = (req, next) => {
  const injector = inject(Injector);
  if (!isDestructiveHttpRequest(req.method, req.url, req.body)) {
    return next(req);
  }
  const permissions = injector.get(PermissionsService);
  if (permissions.canPerformDestructiveAction()) {
    return next(req);
  }
  return throwError(() => new HttpErrorResponse({
    status: 403,
    statusText: 'Forbidden',
    url: req.url,
    error: { message: 'Esta acción no está disponible para usuarios sin permisos asignados.' },
  }));
};
